import React from "react"
import Charts from "../../util/util"
import echarts from "echarts"
import "./pie.less"
const COLORS = [
  "#72E1D7",
  "#3CB1DD",
  "#437CE0",
  "#3040D5",
  "#AC4AEE",
  "#CE4B6C",
]
export default class MyPie extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id: Math.round(Math.random() * 10000000),
    }
  }
  componentDidMount() {
    this.initProps(this.props)
  }
  initProps(props) {
    let { conf = {} } = props
    let { list, title, unit = "" } = conf
    let id = this.getId()
    let option = {
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b}: {c} ({d}%)",
      },

      // legend: {
      //    textStyle: {color: '#fff'},
      //   orient: 'vertical',
      //   x: 'left',
      //   data: list.map(t => {
      //     // console.log(t)
      //     let s = t.name
      //     return s
      //   })
      // },
      color: COLORS,
      series: [
        {
          name: title,
          type: "pie",
          center: ["50%", "50%"],
          radius: ["40%", "55%"],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              formatter: data => {
                return data.name + "\n" + data.value + unit
              },
            },
          },
          labelLine: {
            normal: {
              show: false,
            },
          },
          data: list.map(t => {
            return {
              value: t.value,
              name: t.name,
            }
          }),
        },
      ],
    }

    var chart = this["_" + id]
    if (!chart) {
      chart = this["_" + id] = echarts.init(document.getElementById(id))
      Charts.registerChartsResize(chart)
    }
    chart.setOption(option)
  }
  componentWillReceiveProps(props) {
    this.initProps(props)
  }
  componentWillUnmount() {
    let id = this.getId()
    Charts.destroyCharts(this["_" + id])
  }

  getId() {
    return "ct_pie_" + this.state.id
  }
  renderLegend(list) {
    let { onClick, conf } = this.props
    return (
      <ul className="ls-legend">
        {list.map((item, i) => {
          let c = COLORS[i % COLORS.length]
          return (
            <li
              key={i}
              className={"it-legend"}
              onClick={() => {
                onClick && onClick(item)
              }}
            >
              <span style={{ background: c }} />
              <span>{item.name}</span>
              <span>
                {item.value}
                {conf.unit}
              </span>
            </li>
          )
        })}
      </ul>
    )
  }
  render() {
    let { conf = {} } = this.props
    let { title, list } = conf
    return (
      <div className="ct-pie-ratio">
        <div>{title}</div>
        <div className="chart-inner">
          <div className="chart-inner-pie" id={this.getId()} />
          {this.renderLegend(list)}
        </div>
      </div>
    )
  }
}
